import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getEquipments,
  getEquipmentsByGeneration,
  createEquipment,
  updateEquipment,
  deleteEquipment,
} from '../../lib/vehicleEquipments';

export const fetchEquipments = createAsyncThunk(
  'equipments/getEquipments',
  async () => {
    const data = await getEquipments();
    return data;
  }
);

export const fetchEquipmentsByGeneration = createAsyncThunk(
  'models/fetchEquipmentsByGeneration',
  async ({ vehicleGenerationId }) => {
    const data = await getEquipmentsByGeneration(vehicleGenerationId);

    return data;
  }
);

export const addEquipment = createAsyncThunk(
  'equipments/addEquipment',
  async (body, { rejectWithValue }) => {
    try {
      const data = await createEquipment(body);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const editEquipment = createAsyncThunk(
  'equipments/editEquipment',
  async ({ equipmentId, body }) => {
    const data = await updateEquipment(equipmentId, body);
    return data;
  }
);

export const removeEquipment = createAsyncThunk(
  'equipment/removeEquipment',
  async (equipmentId) => {
    await deleteEquipment(equipmentId);
    return equipmentId;
  }
);
